import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import Datetime from 'react-datetime'
import Modal from 'react-modal'
import $ from 'jquery';
import 'fullcalendar';
import '../Meals/cancelOrder.css';
import {URL_VERSION} from '../../../server/constants';
import {getGradeNamesByNumbers,numToWords,_addNotification,_addNotificationError, gradeNoToText} from '../../../server/util';
import {get,postWithHeadersResponse} from "../../../server/actions";
let converter = require('number-to-words');
let date={}
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
class CancelOrder extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            selectedMonthYear:'',
            defaultDate:new Date(),
            cancelBy:'G',
            gradeList:[],
            studentsList:[],
            mealFilledGrades:[],
            selectAll:false,
            cancellationNote:'',
            selectedStudent:'',
            modalIsOpen: false

        }
        this.bindCalender=this.bindCalender.bind(this);
        this.getMealCreatedGradsByMonth=this.getMealCreatedGradsByMonth.bind(this);
        this.getStudentsByGrade=this.getStudentsByGrade.bind(this);

    }
    componentDidMount(){
        this._notificationSystem = this.refs.notificationSystem;
        let d=new Date()
        date.year = d.getFullYear();
        date.month = d.getMonth()+1;
        this.getMealCreatedGradsByMonth(d.getFullYear()+''+(('0' +(d.getMonth()+1)).slice(-2)));
        this.bindCalender();

    }
    selectDate = (e) => {
        // alert(e)let d = new Date();
        let d = new Date(e);
        d.setMonth(d.getMonth() );
        date.year = d.getFullYear();
        date.month = d.getMonth()+1;
       this.setState({selectedMonthYear:d.getFullYear()+'/'+d.getMonth()+'/'+'1'});
       this.getMealCreatedGradsByMonth(date.year+''+(('0' +(date.month)).slice(-2)));
        this.refs.calendar.closeCalendar();
        this.bindCalender();
    }    
    handleCancelByChange =(e)=>{
        this.setState({
            cancelBy: e.target.value
          });
          this.getMealCreatedGradsByMonth(date.year+''+(('0' +(date.month)).slice(-2)));
    }
    
    getMealCreatedGradsByMonth(monthYear){
        get(URL_VERSION+'/mealCreatedGrades?itemType=Lunch&mealSchoolId=' + sessionStorage.getItem('SchoolId') +'&yearMonth='+monthYear+'&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('ordered meal grades', response);
            return response.json();
        }).then(data => {
            console.log('ordered meal grades', data);
            let finalArray=[]; 
            let respGradeNumberData=getGradeNamesByNumbers(data).split(',');
            finalArray= this.props.schoolGrades.map(item=>{
                let obj={grade:item,checked:false,enabled:false};
                if(respGradeNumberData.includes(''+item)){
                    obj.grade=item;
                    obj.checked=false;
                    obj.enabled=true;
                }                
                return obj;
            });
            this.setState({gradeList:finalArray});
        })
        .catch(
            (error) => {
                console.log('Get orderlist response', error)
            }
        )
    }
    getStudentsByGrade=(gradeName,yearMonth)=>{
        get('/reports/orderSummaryReport?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&yearMonths=' + yearMonth + '&grades=' + gradeName + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log('data', data);
            let studentData = [];
            console.log('student data', studentData);
            data.forEach(student=>{
                studentData.push({id:student.studentRecId,name:student.studentLName + ', ' + student.studentFName});
            });
           
            this.setState({studentsList:studentData});

        }).catch(
            (error) => {                
                console.log('Get School data response', error)
            }
        );
    }

    checkAllGrades = (event) => {      
        let value=event.target.value;
        let selected=event.target.checked;
        let checkboxArray=this.state.gradeList;
            if(this.state.cancelBy=='G'){       
                let itm,index;
                
                checkboxArray.forEach((item,i)=>{
                        if(value=='select_all'){
                            if(item.enabled==true){
                                item.checked=selected;
                                itm=item;
                                index=i
                               // return true;
                            }  
                        }
                        else{
                        if(item.grade==value){
                            item.checked=selected;
                            itm=item;
                            index=i
                            return true;
                        }
                    }
                });
            checkboxArray[index]=itm;
            this.setState({gradeList:checkboxArray});
            var checkboxes = document.getElementsByName("grades");
            let checkboxList=[]
            checkboxes.forEach(item=>{
                if(!item.disabled){
                    checkboxList.push(item);
                }
            })
            
            var select_all = document.getElementById("select_all");
            if(value=='select_all'){                
                select_all.checked=selected;
            }
            else{
            let j = 0;
            for (let i = 0; i < checkboxList.length; i++) {
                if (checkboxList[i].checked) {
                    j++
                }
            }
           

            if (j === checkboxList.length) {               
                   // this.setState({selectAll:true});                    
                select_all.checked = true;
            } else {
               // this.setState({selectAll:false});
                select_all.checked = false;
            }
        }
        }
        else{
                checkboxArray.forEach((item,i)=>{           
                    if(item.grade==value){
                        item.checked=selected;
                    }
                    else{
                        item.checked=false;
                    }
                });
                this.setState({gradeList:checkboxArray});
                if(selected)
                    this.getStudentsByGrade(gradeNoToText(value),date.year+''+(('0' +(date.month)).slice(-2)));
                else
                    this.setState({studentsList:[]});
        }
    }
    bindCalender(){
        let stateObj=this;
        $('#calendar').fullCalendar('destroy');
        $('#calendar').fullCalendar({
            defaultDate: (stateObj.state.selectedMonthYear||'')==''?new Date(): new Date(stateObj.state.selectedMonthYear),
            themeSystem: 'bootstrap3',
            disableDragging: true,
            height: 'auto',
            header: false,
            weekends: false,            
            displayEventTime: false,
            editable: false,
            fixedWeekCount: false,
            droppable: false, // this allows things to be dropped onto the calendar
            dayRender: function (date, cell) {
                var dateNow= (stateObj.state.selectedMonthYear||'')==''?new Date(): new Date(stateObj.state.selectedMonthYear)
                if(dateNow <= date._d &&  new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 1)>date._d){
               // cell.css("background-color", "red");
               $(cell).append('<div class="cell"><div class="firstlayer" style="width:100%"></div><div class="middle"><div class="text"><i class="fa fa-check"></i></div></div></div>');                
                $(cell).on('click',function(){
                    $(this).toggleClass("selected");
                });
            }
            }
        });
    }

    onSubmit=()=>{
        this.setState({ modalIsOpen: false});
        var reqObj={gradeList:[],dateList:[]};
        reqObj.yearMonth=date.year+''+('0' +(date.month)).slice(-2);
        this.state.gradeList.forEach(item=>{
            if(item.checked){
                reqObj.gradeList.push(gradeNoToText(item.grade));
            }
        });        
        if(reqObj.gradeList<=0){
            _addNotificationError('Select atleast once grade.',this);
          return false;
        }
        if(this.state.cancellationNote.trim()==''){
            _addNotificationError('Required reason for cancellation.',this);
            return false;
        }
        reqObj.cancellationNote=this.state.cancellationNote;
        if(this.state.cancelBy=='G'){
            reqObj.isGradeWise=true;
        }else{
            reqObj.isGradeWise=false;
           if(this.state.selectedStudent==''){
            _addNotificationError('Select student.',this);
            return false;
           }
           else{
            reqObj.studentRecordIds=[this.state.selectedStudent];
           }
        }

        let selectedDays=[]
        $('#calendar').find('.selected').each(function (){
            selectedDays.push($(this).attr('data-date'))
        })

        if(selectedDays.length<=0){
            _addNotificationError('Select atleast one day for cancelation.',this);
            return false;
        }
        reqObj.dateList=selectedDays;
        reqObj.loggedUser=sessionStorage.getItem('loggedUserName');
        let headers = {
            'Content-Type': 'application/json'
        };
        

        postWithHeadersResponse(URL_VERSION+'/menuOrderCancel?mealSchoolId='+sessionStorage.getItem('SchoolId')+'&access_token=', JSON.stringify(reqObj),headers).then((response) => {
            if (response.statusCode!==200) {               
                throw Error(response.statusMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            _addNotification(res.statusMessage, this);
            setTimeout(() => {
                window.location.replace('/schoolAdmin/viewOrdersGrid');
                //this.context.router.history.push('/schoolAdmin/viewMenu')
            }, 3000);
        }).catch(
            (error) => {
                 _addNotificationError(error.message,this);               
            }
        )
    }

    

    render() {
        return (
            <section className="full-width clearfix">
            <NotificationSystem ref="notificationSystem"/>
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>

                <div className="container">
                    <div className="sectionTitle">
                        <h2>                       
                            <span>Cancel Order </span>                      
                        </h2>
                    </div>
                    <div className="col-md-8 col-sm-12 col-xs-12 text-center createmenu-panel">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title">Cancel Menu</h3>
                                </div>
                                <div className="panel-body">
                                <div className="form-group uploadFileInfo col-md-12 createmenu-month-group">
                                <label className="custom-label col-sm-3 text-left">Cancel order by</label>
                                <div className="input-group col-sm-7 col-sm-12 col-xs-12">
                                <input type="radio"  name="cancelBy" value="G" id='group' checked={this.state.cancelBy=='G'} onChange={this.handleCancelByChange}  /><label for='group'>Grade</label> 
                                <input type="radio" name="cancelBy" value="S" id='student' checked={this.state.cancelBy=='S'} onChange={this.handleCancelByChange} /> <label for='student'>Student</label>  
                                 
                                </div>
                                </div>
                                    <div className="form-group uploadFileInfo col-md-12 createmenu-month-group">
                                            <label className="custom-label col-sm-3 text-left">Select Month</label>
                                            <div className="input-group col-sm-7 col-sm-12 col-xs-12">

                                                <Datetime ref='calendar' dateFormat="MMMM YYYY" timeFormat={false}
                                                        closeOnSelect={true}
                                                        defaultValue={this.state.defaultDate}
                                                        onChange={this.selectDate}/>
                                                <button className="input-group-addon" disabled>
                                                    <i className="fa fa-calendar"> </i>
                                                </button>
                                            </div>

                                    </div>
                                    <div className="form-group col-md-12 createmenu-grade-group">
                                        <label className="custom-label col-sm-3 text-left">Select Grades</label>
                                        <div className="col-sm-9">
                                            <div class="styled-input-container styled-input--square">
                                               {
                                                   (this.state.cancelBy=='S'?null: <div class="styled-input-single col-sm-12">
                                                    <input type="checkbox" name="select_all" id="select_all" value='select_all'
                                                           onChange={this.checkAllGrades}/>
                                                    <label for="select_all">All</label>
                                                </div>)
                                               }
                                                {this.state.gradeList.map(grade => {
                                                        return (
                                                            <div className="styled-input-single col-sm-2 pull-left"
                                                                 style={{margin: '-15px 0px'}}>
                                                               <input type="checkbox" name="grades"
                                                                       onChange={this.checkAllGrades}
                                                                       id={grade.grade} value={grade.grade} 
                                                                       checked={grade.checked?true:false}
                                                                       disabled={grade.enabled?false:true}
                                                                       />
                                                                <label className={ !grade.enabled? 'disable-checkbox':''}  for={grade.grade}>{grade.grade}</label>

                                                            </div>
                                                        );

                                                    }
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        (this.state.cancelBy=='G'?null:
                                            <div className="form-group col-md-12 createmenu-grade-group">
                                                <label className="custom-label col-sm-3 text-left">Select Student</label>
                                                <div className="col-sm-9">
                                                    <div class="styled-input-container styled-input--square">
                                                        <select className='form-control' value={this.state.selectedStudent} onChange={(e)=>{this.setState({selectedStudent:e.target.value})}} >
                                                            <option value=''></option>
                                                            {
                                                                this.state.studentsList.map(student=>{
                                                                    return (<option value={student.id}>
                                                                    {student.name}
                                                                    </option>);

                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                     <div className="form-group col-md-12 createmenu-grade-group">
                                                <label className="custom-label col-sm-3 text-left">Reason for cancellation</label>
                                                <div className="col-sm-9">
                                                    <div class="styled-input-container styled-input--square">
                                                    <input type='text' className='form-control'value={this.state.cancellationNote} onChange={(e)=>{this.setState({cancellationNote:e.target.value})}} />
                                                    </div>
                                                </div>
                                        </div>

                                    <div className="form-group col-md-12 createmenu-grade-group">
                                        <div id='calendar'>

                                        </div>
                                    </div>
                                    <div className="form-group col-md-12 text-center">
                                        <button type="button" id="submit" onClick={() => this.setState({modalIsOpen: true})}  className="btn btn-sm btn-primary"><i
                                            className="fa fa-arrow-circle-right"></i><span>Submit</span></button>
                                    </div>


                                </div>
                            </div>
                            
                    </div>
                    </div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={() => this.setState({modalIsOpen: false})}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <div className="modal-header">
                                <h4 className="modal-title modal-title-color" id="deleteLabel">Conformation for cancel meal</h4>
                                </div>
                                <div className="modal-body">
                                    <p>Are you sure you want to cancel the meal order for selected days?</p>
                                </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={() => this.setState({ modalIsOpen: false})}><i
                                            className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <button type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} onClick={this.onSubmit}
                                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                                    </button>
                                </div>
                    </Modal>

                    </section>
        );
    }
}
export default CancelOrder;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Meals/cancelOrder.jsx